(function(app) {

    app.filter("noExtension",
        function() {
            return function(fileName) {
                return fileName.substring(0, fileName.lastIndexOf("."));
            }
        });

})(window.app); //jshint ignore:line